// extracted by mini-css-extract-plugin
module.exports = {"container":"AddressCard_container__q4u4W","titleSection":"AddressCard_titleSection__IEA9k","title":"AddressCard_title__vlxHe"};